import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/charge-types'
)({
  meta: () => [{ title: MENU.CHARGE_TYPE }]
})
